import { Outlet } from "react-router-dom";
import { useHasRole } from "../../hooks/useHasRole";
import { ROLES } from "../../context/dataApplicationsContext";
import ErrorUnauthorize from "../../components/ErrorUnauthorize";

const RequireAdmin = () => {
  const isAdmin = useHasRole(ROLES.ADMIN);

  return (
    isAdmin
      ? <Outlet />
      : <ErrorUnauthorize />
  )
}

export default RequireAdmin